import React, { useEffect, useState } from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import PaceLogo from "../../assets/images/pacelogo.png";
import { FiMenu, FiX, FiChevronDown, FiChevronUp } from "react-icons/fi"; // Import menu icons
import { useNavigate } from "react-router-dom";

const CustomNavbar = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [openDropdown, setOpenDropdown] = useState({});
  const [userPermissions, setUserPermissions] = useState([]);
  const [userDefinedPermissions, setUserDefinedPermissions] = useState([]);
  const [hasDualRole, setHasDualRole] = useState(false); // kept for backward compatibility, but toggle now keys off Team Leader perm
  const [currentMode, setCurrentMode] = useState("team_leader"); // "team_leader" or "hr_associate"

  const navigate = useNavigate();

  const [isSuperuser, setIsSuperuser] = useState(() => {
    return localStorage.getItem("is_superuser") === "true";
  });

  useEffect(() => {
    let x = localStorage.getItem("is_superuser");
    setIsSuperuser(x === "true"); // Convert to boolean

    const storedPermissions =
      JSON.parse(localStorage.getItem("custom_permissions")) || [];
    setUserPermissions(storedPermissions);

    const storedPermissions2 =
      JSON.parse(localStorage.getItem("user_defined_permissions")) || [];
    setUserDefinedPermissions(storedPermissions2);

    // Check if user has dual role permission (still used in a few places),
    // but the toggle itself will now be shown for *all* team leaders.
    const hasDualRoleFlag = storedPermissions.includes("auth.leaderanddocladderteam");
    const hasLeaderPerm = storedPermissions.includes("auth.Custom_team_leader_perm");
    const hasUploadPerm = storedPermissions.includes("website.custom_user_view");
    const isDualRole = hasDualRoleFlag || (hasLeaderPerm && hasUploadPerm);
    setHasDualRole(isDualRole);

    // Get saved mode or default to team_leader
    const savedMode = localStorage.getItem("user_current_mode") || "team_leader";
    setCurrentMode(savedMode);
  }, []);

  // Toggle between Team Leader and HR Associate modes
  const handleModeToggle = () => {
    const newMode = currentMode === "team_leader" ? "hr_associate" : "team_leader";
    setCurrentMode(newMode);
    localStorage.setItem("user_current_mode", newMode);

    // Navigate to appropriate dashboard
    if (newMode === "team_leader") {
      navigate("/teamleaderview");
    } else {
      navigate("/UserViews");
    }
  };

  // Helper function to check if user has any of the specified permissions
  const hasPermission = (...permissionNames) => {
    if (isSuperuser) return true; // Superusers have all permissions
    return permissionNames.some(permName => userDefinedPermissions.includes(permName));
  };

  // Helper function to check Django permissions
  const hasDjangoPermission = (...permissionNames) => {
    if (isSuperuser) return true;
    return permissionNames.some(permName => userPermissions.includes(permName));
  };

  const toggleSidebar = () => {
    setCollapsed((prevState) => !prevState); // Toggle the collapsed state
  };

  const handleDropdownToggle = (menuName) => {
    setOpenDropdown((prev) => (prev === menuName ? null : menuName));
  };

  const canViewAnalytics = hasPermission(
    "Pace User Wise Analytics",
    "Team Leaders Wise Analytics",
    "Docladder User Wise Analytics"
  );

  console.log("isSuperuser:", isSuperuser);
  console.log("userDefinedPermissions:", userDefinedPermissions);

  return (
    // <div style={{  backgroundColor: "#082f49" }}>
    <div className="bg-blue-500">
      <Sidebar
        className="bg-blue-500"
        collapsed={collapsed}
        style={{
          opacity: "1",
          zIndex: 9999,
          // maxHeight: "100vh",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "#fff",
            }}
          >
            <Box
              bg="#fff"
              color="#b6c8d9"
              fontSize="xl"
              fontWeight="bold"
              textAlign="center"
              style={{
                padding: "10px",
                color: "white",
                height: "70px",
                marginTop: "5px",
              }}
            >
              {!collapsed && (
                <img
                  src={PaceLogo}
                  alt="Pace Logo"
                  style={{
                    borderRadius: "5px",
                    maxWidth: "160px",
                    height: "50px",
                    width: "160px",
                  }}
                />
              )}
            </Box>

            <Box
              bg="#fff"
              color="var(--bs-blue)"
              fontSize="xl"
              fontWeight="bold"
              textAlign="center"
              style={{
                padding: "10px",
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
              onClick={toggleSidebar}
            >
              {collapsed ? (
                <FiMenu
                  size={24}
                  style={{ marginLeft: "-35px", alignItems: "center" }}
                />
              ) : (
                <FiX style={{ display: "flex" }} size={24} />
              )}
            </Box>
          </div>
        </div>

        {/* Dual Entry Toggle Button: show for any non-superuser Team Leader */}
        {!isSuperuser && (
          userPermissions.includes("auth.Custom_team_leader_perm") ||
          userDefinedPermissions.includes("Team Leader Current Month Records") ||
          userDefinedPermissions.includes("Team Leaders Wise Analytics")
        ) && (
            <div style={{ padding: collapsed ? "10px" : "15px", borderBottom: "2px solid #082f49" }}>
              <button
                onClick={handleModeToggle}
                className="w-full rounded-lg font-semibold text-sm transition-all shadow-md"
                style={{
                  background: currentMode === "team_leader"
                    ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                    : "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                  color: "white",
                  border: "2px solid white",
                  padding: collapsed ? "10px" : "12px 16px",
                }}
                title={currentMode === "team_leader" ? "Switch to HR Mode" : "Switch to Leader Mode"}
              >
                {collapsed ? (
                  <div className="flex items-center justify-center">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                    </svg>
                  </div>
                ) : (
                  <>
                    <div className="flex items-center justify-center gap-2">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                      </svg>
                      <span>
                        {currentMode === "team_leader" ? "Switch to HR Mode" : "Switch to Leader Mode"}
                      </span>
                    </div>
                    <div className="text-xs mt-1 opacity-90">
                      Current: {currentMode === "team_leader" ? "Team Leader" : "HR Associate"}
                    </div>
                  </>
                )}
              </button>
            </div>
          )}

        <Menu
          menuItemStyles={{
            button: {
              display: "flex",
              alignItems: "center",
              gap: "10px", // Space between icon and text
              padding: "12px 16px",
              [`&.active`]: {
                backgroundColor: "#082f49",
                color: "#000",
              },
              [`&:hover`]: {
                backgroundColor: "#082f49",
                color: "#fff",
              },
            },
          }}
          style={{
            // background: "linear-gradient(180deg, #025aa5, #003366)",
            color: "white",
            width: "auto",
            height: "100%",
          }}
          className="bg-blue-500"
        >
          {hasPermission("Announcements", "Latest News View") && (
            <>
              <MenuItem component={<Link to="/news" />}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-megaphone"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-.214c-2.162-1.241-4.49-1.843-6.912-2.083l.405 2.712A1 1 0 0 1 5.51 15.1h-.548a1 1 0 0 1-.916-.599l-1.85-3.49-.202-.003A2.014 2.014 0 0 1 0 9V7a2.02 2.02 0 0 1 1.992-2.013 75 75 0 0 0 2.483-.075c3.043-.154 6.148-.849 8.525-2.199zm1 0v11a.5.5 0 0 0 1 0v-11a.5.5 0 0 0-1 0m-1 1.35c-2.344 1.205-5.209 1.842-8 2.033v4.233q.27.015.537.036c2.568.189 5.093.744 7.463 1.993zm-9 6.215v-4.13a95 95 0 0 1-1.992.052A1.02 1.02 0 0 0 1 7v2c0 .55.448 1.002 1.006 1.009A61 61 0 0 1 4 10.065m-.657.975 1.609 3.037.01.024h.548l-.002-.014-.443-2.966a68 68 0 0 0-1.722-.082z" />
                  </svg>
                  {!collapsed && <span> Announcements</span>}
                </div>
              </MenuItem>
            </>
          )}

          {/* My Records - For Regular HR Users ONLY (NOT Team Leaders, NOT Marketing team) */}
          {!isSuperuser &&
            userPermissions.includes("website.custom_user_view") &&
            !hasPermission("Marketing View") && (
              <>
                <MenuItem component={<Link to="/UserViews" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-upload"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                      <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                    </svg>
                    {!collapsed && <span> My Records & Upload</span>}
                  </div>
                </MenuItem>
              </>
            )}

          {/* Team Leader Dashboard - For Team Leaders ONLY */}
          {!isSuperuser && userPermissions.includes("auth.Custom_team_leader_perm") && (
            <>
              <MenuItem component={<Link to="/teamleaderview" />}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-person-badge"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                    <path d="M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492z" />
                  </svg>
                  {!collapsed && <span> Team Leader Dashboard</span>}
                </div>
              </MenuItem>
            </>
          )}

          {/* Docladder Dashboard - For Docladder Members ONLY */}
          {!isSuperuser && userPermissions.includes("auth.Custom_team_docladder_perm") && (
            <>
              <MenuItem component={<Link to="/teamdocladderview" />}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-person-lines-fill"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z" />
                  </svg>
                  {!collapsed && <span> Docladder Dashboard</span>}
                </div>
              </MenuItem>
            </>
          )}

          {hasPermission("Commitments") && (
            <>
              <MenuItem component={<Link to="/CommitmentList" />}>
                <div style={{ display: "flex", alignItems: "center" }}>

                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-journal-check" viewBox="0 0 16 16" style={{ marginRight: "8px" }}>
                    <path fillRule="evenodd" d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                    <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2" />
                    <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z" />
                  </svg>
                  {!collapsed && <span> Commitments</span>}
                </div>
              </MenuItem>
            </>
          )}

          {/* **************************************** Medical College ********************************** */}

          {/* <div
            onClick={() => handleDropdownToggle("medicalcollege")}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 15px",
              backgroundColor: "transparent",
              color: "white",
              borderRadius: "5px",
              cursor: "pointer",
              marginBottom: "5px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-hospital"
                viewBox="0 0 16 16"
                style={{ marginRight: "8px" }}
              >
                <path d="M8.5 5.034v1.1l.953-.55.5.867L9 7l.953.55-.5.866-.953-.55v1.1h-1v-1.1l-.953.55-.5-.866L7 7l-.953-.55.5-.866.953.55v-1.1h1ZM13.25 9a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5ZM13 11.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5Zm.25 1.75a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5Zm-11-4a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5A.25.25 0 0 0 3 9.75v-.5A.25.25 0 0 0 2.75 9h-.5Zm0 2a.25.25 0 0 0-.25.25v.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25h-.5ZM2 13.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5Z" />
                <path d="M5 1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 1 1v4h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1V1Zm2 14h2v-3H7v3Zm3 0h1V3H5v12h1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3Zm0-14H6v1h4V1Zm2 7v7h3V8h-3Zm-8 7V8H1v7h3Z" />
              </svg>
              <span>{!collapsed && <span>Medical College</span>}</span>
            </div>
            {openDropdown === "medicalcollege" ? (
              <FiChevronUp />
            ) : (
              <FiChevronDown />
            )}
          </div>

          {openDropdown === "medicalcollege" && (
            <div
              style={{
                padding: "10px 30px",
                background: "#CAF0F8",
                borderRadius: "5px",
                marginTop: "5px",
              }}
            >
              <Link
                to="/MedicalCollegeList"
                style={{
                  textDecoration: "none",
                  color: "#0077B6",
                  marginTop: "10px",
                  padding: "5px",
                  display: "flex",
                }}
                replace
              >
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-building"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#0284c7",
                      marginRight: "8px",
                      marginTop: "5px",
                    }}
                  >
                    <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z" />
                    <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1Zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3V1Z" />
                  </svg>
                  {!collapsed && <span>Medical Colleges</span>}
                </span>
              </Link>

              <Link
                to="/MedicalCollegeCandidates"
                style={{
                  textDecoration: "none",
                  color: "#0077B6",
                  marginTop: "10px",
                  padding: "5px",
                  display: "flex",
                }}
                replace
              >
                <span
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-people"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#0284c7",
                      marginRight: "8px",
                      marginTop: "5px",
                    }}
                  >
                    <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" />
                  </svg>
                  {!collapsed && <span>Candidates</span>}
                </span>
              </Link>
            </div>
          )} */}

          {/* Home (Team Leader User View) - hide for superadmin */}
          {!isSuperuser && hasPermission("Team Leader User View") && (
            <>
              <MenuItem component={<Link to="/teamleaderview" />}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-files"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2m0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1M3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />
                  </svg>
                  {!collapsed && <span> Home</span>}
                </div>
              </MenuItem>
            </>
          )}

          <>
            {/* **************************************** Pace Team ********************************** */}

            {hasPermission("Pace Current Month Records", "Pace Prev Month Records", "Create Pace Member", "Pace User Wise Analytics") && (
              <div
                onClick={() => handleDropdownToggle("hrassociates")}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 15px",
                  backgroundColor: "transparent",
                  color: "white",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginBottom: "5px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-bar-chart"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M4 11H2v3h2zm5-4H7v7h2zm5-5v12h-2V2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z" />
                  </svg>
                  <span>{!collapsed && <span>Pace Team</span>}</span>
                </div>
                {openDropdown === "hrassociates" ? (
                  <FiChevronUp />
                ) : (
                  <FiChevronDown />
                )}
              </div>
            )}

            {openDropdown === "hrassociates" && (
              <div
                style={{
                  padding: "10px 30px",
                  background: "#CAF0F8",
                  borderRadius: "5px",
                  marginTop: "5px",
                }}
              >
                {hasPermission("Create Pace Member") && (
                  <>
                    <Link
                      to="/create"
                      style={{
                        textDecoration: "none",
                        color: "#0077B6",
                        marginTop: "10px",
                        padding: "5px",
                        display: "flex",
                      }}
                      replace
                    >
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-lg"
                          viewBox="0 0 16 16"
                          style={{
                            color: "#0284c7",
                            marginRight: "3px",
                            marginTop: "5px",
                          }}
                        >
                          <path
                            fillRule="evenodd"
                            d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                          />
                        </svg>
                        {!collapsed && <span> Create </span>}
                      </span>
                    </Link>
                  </>
                )}

                {hasPermission("Pace Current Month Records") && (
                  <Link
                    to="/records"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="currentColor"
                        className="bi bi-eye"
                        viewBox="0 0 16 16"
                        style={{
                          color: "#0284c7",
                          marginRight: "8px",
                          marginTop: "5px",
                        }}
                      >
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                      </svg>
                      {!collapsed && <span> HR Associates</span>}
                    </span>
                  </Link>
                )}

                {hasPermission("Pace Prev Month Records") && (
                  <Link
                    to="/prevMonthRecord"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-bar-chart-line-fill"
                        viewBox="0 0 16 16"
                        style={{
                          color: "#0284c7",
                          marginRight: "8px",
                          marginTop: "5px",
                        }}
                      >
                        <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1z" />
                      </svg>
                      {!collapsed && <span> Prev Month</span>}
                    </span>
                  </Link>
                )}

                {hasPermission("Pace User Wise Analytics") && (
                  <Link
                    to="/user-comparison"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                    replace
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-activity"
                        viewBox="0 0 16 16"
                        style={{ marginRight: "8px" }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M6 2a.5.5 0 0 1 .47.33L10 12.036l1.53-4.208A.5.5 0 0 1 12 7.5h3.5a.5.5 0 0 1 0 1h-3.15l-1.88 5.17a.5.5 0 0 1-.94 0L6 3.964 4.47 8.171A.5.5 0 0 1 4 8.5H.5a.5.5 0 0 1 0-1h3.15l1.88-5.17A.5.5 0 0 1 6 2"
                        />
                      </svg>
                      {!collapsed && <span> Comparision</span>}
                    </span>
                  </Link>
                )}
              </div>
            )}

            {/* **************************************** Team Leaders ********************************** */}

            {hasPermission("Create Team Leader Member", "Team Leader Prev Month Records", "Team Leader Current Month Records", "Team Leaders Wise Analytics") && (
              <>
                <div
                  onClick={() => handleDropdownToggle("teamleaders")}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 15px",
                    backgroundColor: "transparent",
                    color: "white",
                    borderRadius: "5px",
                    cursor: "pointer",
                    marginBottom: "5px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-diagram-3"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zM0 11.5A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"
                      />
                    </svg>
                    <span>{!collapsed && <span>Team Leaders</span>}</span>
                  </div>
                  {openDropdown === "teamleaders" ? (
                    <FiChevronUp />
                  ) : (
                    <FiChevronDown />
                  )}
                </div>
              </>
            )}

            {openDropdown === "teamleaders" && (
              <div
                style={{
                  padding: "10px 30px",
                  background: "#CAF0F8",
                  borderRadius: "5px",
                  marginTop: "5px",
                }}
              >
                {hasPermission("Create Team Leader Member") && (
                  <Link
                    to="/createteamleader"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                    replace
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-lg"
                        viewBox="0 0 16 16"
                        style={{
                          color: "#0284c7",
                          marginRight: "3px",
                          marginTop: "5px",
                        }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                        />
                      </svg>
                      {!collapsed && <span> Create </span>}
                    </span>
                  </Link>
                )}
                {hasPermission("Team Leader Prev Month Records") && (
                  <Link
                    to="/ShowPrevMonthTeamLeader"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-bar-chart-line-fill"
                        viewBox="0 0 16 16"
                        style={{
                          color: "#0284c7",
                          marginRight: "8px",
                          marginTop: "5px",
                        }}
                      >
                        <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1z" />
                      </svg>
                      {!collapsed && <span> Prev Month</span>}
                    </span>
                  </Link>
                )}
                {hasPermission("Team Leader Current Month Records") && (
                  <Link
                    to="/showteamleader"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                    replace
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="currentColor"
                        className="bi bi-eye"
                        viewBox="0 0 16 16"
                        style={{
                          color: "#0284c7",
                          marginRight: "8px",
                          marginTop: "5px",
                        }}
                      >
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                      </svg>
                      {!collapsed && <span> Leaders List</span>}
                    </span>
                  </Link>
                )}
              </div>
            )}

            {/* *************************************************** Docladder *********************************************** */}

            {hasPermission("Docladder Current Month Records", "Docladder Prev Month Records", "Docladder User Wise Analytics", "Create Docladder Member") && (
              <div
                onClick={() => handleDropdownToggle("docladder")}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 15px",
                  backgroundColor: "transparent",
                  color: "white",
                  borderRadius: "5px",
                  cursor: "pointer",
                  marginBottom: "5px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "8px", fontWeight: "800" }}>
                    D
                  </span>
                  <span>{!collapsed && <span> Docladder</span>}</span>
                </div>
                {openDropdown === "docladder" ? (
                  <FiChevronUp />
                ) : (
                  <FiChevronDown />
                )}
              </div>
            )}
            {openDropdown === "docladder" && (
              <div
                style={{
                  padding: "10px 30px",
                  background: "#CAF0F8",
                  borderRadius: "5px",
                  marginTop: "5px",
                }}
              >
                {hasPermission("Create Docladder Member") && (
                  <Link
                    to="/createdocladdermember"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                    replace
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-lg"
                        viewBox="0 0 16 16"
                        style={{
                          color: "#0284c7",
                          marginRight: "3px",
                          marginTop: "5px",
                        }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                        />
                      </svg>
                      {!collapsed && <span> Create </span>}
                    </span>
                  </Link>
                )}

                {hasPermission("Docladder Current Month Records") && (
                  <Link
                    to="/showdocladdermember"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                    replace
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="currentColor"
                        className="bi bi-eye"
                        viewBox="0 0 16 16"
                        style={{
                          color: "#0284c7",
                          marginRight: "8px",
                          marginTop: "5px",
                        }}
                      >
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                      </svg>
                      {!collapsed && <span> Records</span>}
                    </span>
                  </Link>
                )}

                {hasPermission("Docladder Prev Month Records") && (
                  <Link
                    to="/DocladderPrevMonthRecords"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-bar-chart-line-fill"
                        viewBox="0 0 16 16"
                        style={{
                          color: "#0284c7",
                          marginRight: "8px",
                          marginTop: "5px",
                        }}
                      >
                        <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1z" />
                      </svg>
                      {!collapsed && <span> Prev Month </span>}
                    </span>
                  </Link>
                )}
                {hasPermission("Docladder User Wise Analytics") && (
                  <Link
                    to="/docladdercomparision"
                    style={{
                      textDecoration: "none",
                      color: "#0077B6",
                      marginTop: "10px",
                      padding: "5px",
                      display: "flex",
                    }}
                    replace
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-activity"
                        viewBox="0 0 16 16"
                        style={{ marginRight: "8px" }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M6 2a.5.5 0 0 1 .47.33L10 12.036l1.53-4.208A.5.5 0 0 1 12 7.5h3.5a.5.5 0 0 1 0 1h-3.15l-1.88 5.17a.5.5 0 0 1-.94 0L6 3.964 4.47 8.171A.5.5 0 0 1 4 8.5H.5a.5.5 0 0 1 0-1h3.15l1.88-5.17A.5.5 0 0 1 6 2"
                        />
                      </svg>
                      {!collapsed && <span> Comparision </span>}
                    </span>
                  </Link>
                )}
              </div>
            )}

            {hasPermission("Closing Report View") && (
              <MenuItem component={<Link to="/closingReport" />}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-graph-up-arrow"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px" }}
                  >
                    <path
                      fillRule="evenodd"
                      d="M0 0h1v15h15v1H0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5"
                    />
                  </svg>
                  {!collapsed && <span> Closing Report</span>}
                </div>
              </MenuItem>
            )}

            {/* Marketing View - Show Upload Marketing Details page, remove user view for marketing team */}
            {hasPermission("Marketing View") && (
              <>
                <MenuItem component={<Link to="/marketingFilePage" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-briefcase"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5m1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0M1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5" />
                    </svg>
                    {!collapsed && <span> Upload Marketing Details</span>}
                  </div>
                </MenuItem>
              </>
            )}

            {hasPermission("Marketing Lead") && (
              <MenuItem component={<Link to="/MarketingLeads" />}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-person-lines-fill"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z" />
                  </svg>
                  {!collapsed && <span> Marketing Leads</span>}
                </div>
              </MenuItem>
            )}

            {hasPermission("Docladder Marketing") && (
              <MenuItem component={<Link to="/DocladderMarketingFilesPage" />}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-briefcase-fill"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5" />
                    <path d="M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85z" />
                  </svg>
                  {!collapsed && <span> Docladder Marketing</span>}
                </div>
              </MenuItem>
            )}

            {hasPermission("Deals Page") && (
              <>
                <MenuItem component={<Link to="/DealsPage" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-currency-dollar"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73z" />
                    </svg>
                    {!collapsed && <span> Deals Page</span>}
                  </div>
                </MenuItem>
              </>
            )}

            {canViewAnalytics && (
              <>
                <MenuItem component={<Link to="/analytics" />}> 
                  {/* Existing Analytics */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-graph-up"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path fillRule="evenodd" d="M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07" />
                    </svg>
                    {!collapsed && <span> Analytics Dashboard</span>}
                  </div>
                </MenuItem>
                <MenuItem component={<Link to="/ai-chat" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-chat-dots"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                      <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.244 1.412c-.147.596-.35 1.13-.628 1.55a.5.5 0 0 0 .51.75zm1.114-1.766a10.7 10.7 0 0 0 .246-1.667c.02-.246-.052-.36-.246-.596C1.943 9.906 1 8.492 1 7c0-3.245 3.109-6 7-6s7 2.755 7 6-3.109 6-7 6a8 8 0 0 1-2.635-.472l-.257-.09-.239.128c-.302.161-1.24.617-2.97 1.077" />
                    </svg>
                    {!collapsed && <span> AI Boardroom</span>}
                  </div>
                </MenuItem>
              </>
            )}

            {hasPermission("Invoices") && (
              <>
                <MenuItem component={<Link to="/invoices" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-receipt"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z" />
                      <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5" />
                    </svg>
                    {!collapsed && <span> Invoices</span>}
                  </div>
                </MenuItem>
                {/*  */}
              </>
            )}

            {hasPermission("Legal") && (
              <>
                <MenuItem component={<Link to="/partnersFiles" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-file-earmark-pdf"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                      <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                    </svg>
                    {!collapsed && <span> Legal</span>}
                  </div>
                </MenuItem>
              </>
            )}

            {/* SOP View - Show for HR Associates and Team Leaders */}
            {(hasPermission("SOP View") ||
              (userPermissions.includes("website.custom_user_view") && !userPermissions.includes("auth.Custom_team_leader_perm")) ||
              userPermissions.includes("auth.Custom_team_leader_perm")) && (
                <>
                  <MenuItem component={<Link to="/soppage" />}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-file-earmark-post"
                        viewBox="0 0 16 16"
                        style={{ marginRight: "8px" }}
                      >
                        <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                        <path d="M4 6.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5" />
                      </svg>
                      {!collapsed && <span> SOP</span>}
                    </div>
                  </MenuItem>
                </>
              )}

            {hasPermission("MOM", "Minutes of Meeting View") && (
              <>
                <MenuItem component={<Link to="/momlist" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-file-earmark-bar-graph"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M10 13.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5z" />
                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                    </svg>
                    {!collapsed && <span> MOM</span>}
                  </div>
                </MenuItem>
              </>
            )}
            {/*  */}
            {hasPermission("Advance") && (
              <>
                <MenuItem component={<Link to="/advpage" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-cash-coin"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
                      />
                      <path d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195z" />
                      <path d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z" />
                      <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 6 6 0 0 1 3.13-1.567" />
                    </svg>
                    {!collapsed && <span> Advance</span>}
                  </div>
                </MenuItem>
              </>
            )}
            {isSuperuser && (
              <>
                <MenuItem component={<Link to="/PermissionPage" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-person-gear"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
                    </svg>
                    {!collapsed && <span> Permissions</span>}
                  </div>
                </MenuItem>
                <MenuItem component={<Link to="/UserManagement" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-people-fill"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
                    </svg>
                    {!collapsed && <span> User Management</span>}
                  </div>
                </MenuItem>
                <MenuItem component={<Link to="/DatabaseBackup" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-database-fill-down"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M12.5 9a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7m.354 5.854 1.5-1.5a.5.5 0 0 0-.708-.708l-.646.647V10.5a.5.5 0 0 0-1 0v2.793l-.646-.647a.5.5 0 0 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0M8 1c-1.573 0-3.022.289-4.096.777C2.875 2.227 2 2.666 2 3s.875.773 1.904 1.223C4.978 4.711 6.427 5 8 5s3.022-.289 4.096-.777C13.125 3.773 14 3.334 14 3s-.875-.773-1.904-1.223C11.022 1.289 9.573 1 8 1" />
                      <path d="M2 4v2c0 .334.875.773 1.904 1.223C4.978 7.711 6.427 8 8 8s3.022-.289 4.096-.777C13.125 6.773 14 6.334 14 6V4c0 .334-.875.773-1.904 1.223C11.022 5.711 9.573 6 8 6s-3.022-.289-4.096-.777C2.875 4.773 2 4.334 2 4m0 3v2c0 .334.875.773 1.904 1.223C4.978 10.711 6.427 11 8 11s3.022-.289 4.096-.777C13.125 9.773 14 9.334 14 9V7c0 .334-.875.773-1.904 1.223C11.022 8.711 9.573 9 8 9z" />
                    </svg>
                    {!collapsed && <span> Database Backup</span>}
                  </div>
                </MenuItem>
              </>
            )}

            {hasPermission("Medical College") && (
              <>
                <MenuItem component={<Link to="/MedicalCollegeList" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-buildings" viewBox="0 0 16 16" style={{ marginRight: "8px" }}>
                      <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022M6 8.694 1 10.36V15h5zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5z" />
                      <path d="M2 11h1v1H2zm2 0h1v1H4zm-2 2h1v1H2zm2 0h1v1H4zm4-4h1v1H8zm2 0h1v1h-1zm-2 2h1v1H8zm2 0h1v1h-1zm2-2h1v1h-1zm0 2h1v1h-1zM8 7h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zM8 5h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zm0-2h1v1h-1z" />
                    </svg>
                    {!collapsed && <span> Medical College</span>}
                  </div>
                </MenuItem>
              </>
            )}

            {hasPermission("Company List") && (
              <>
                <MenuItem component={<Link to="/CompanyList" />}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-building"
                      viewBox="0 0 16 16"
                      style={{ marginRight: "8px" }}
                    >
                      <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" />
                      <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3z" />
                    </svg>
                    {!collapsed && <span> Company</span>}
                  </div>
                </MenuItem>
              </>
            )}

            {/* **************************************** Audit System ********************************** */}

            {/* Audit Section - Show for Superusers or users with "Audit Section" permission */}
            {(isSuperuser || hasPermission("Audit Section", "Audit section")) && (
              <MenuItem component={<Link to="/audit-users" />}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-shield-check"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                    <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                  </svg>
                  {!collapsed && <span> Audit Section</span>}
                </div>
              </MenuItem>
            )}


            {/*  */}
            <MenuItem component={<Link to="/" />}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-box-arrow-right"
                  viewBox="0 0 16 16"
                  style={{ marginRight: "8px" }}
                >
                  <path
                    fillRule="evenodd"
                    d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
                  />
                  <path
                    fillRule="evenodd"
                    d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                  />
                </svg>
                {!collapsed && <span> Sign Out</span>}
              </div>
            </MenuItem>
          </>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default CustomNavbar;
